<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.subscribers', 1) }}
                    </h3>
                </div>
            </div>

            <div class=" " :class="[ mobileView ? 'pt-3': 'card-body']">
                <b-form @reset="onReset" v-if="show">
                    <div class=" " :class="[ mobileView ? '': 'container']">

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="lastName-group"
                                        :label="$t('message.lastName')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.nom.$model"
                                            :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="firstName-group"
                                        :label="$t('message.firstName')"
                                        label-for="firstName"
                                        description=""
                                >
                                    <b-form-input
                                            id="firstName"
                                            v-model="$v.form.prenom.$model"
                                            :state="$v.form.prenom.$dirty ? !(errorshasField('prenom') || $v.form.prenom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('prenom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.prenom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('prenom')">
                                        {{ getErrorsField('prenom') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col sm="6">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone"
                                >
                                    <vue-tel-input  class="form-control"
                                            id="telephone"
                                            v-model="$v.form.telephone.$model"
                                            required
                                            placeholder=""
                                            :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"
                                            @focus="clearErrorField('telephone')"
                                            >
                                    </vue-tel-input>

                                    <b-form-invalid-feedback v-if="!$v.form.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="!$v.form.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="!$v.form.telephone.numeric">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="email-group"
                                        :label="$t('message.email')"
                                        label-for="email"
                                >
                                    <b-form-input
                                            id="email"
                                            v-model="$v.form.email.$model"
                                            :state="$v.form.email.$dirty ? !(errorshasField('email') || $v.form.email.$error) : null"
                                            type="email"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('email')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.email.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.email.email">
                                        {{ $t('message.emailNotValid') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="sexe-group"
                                        :label="$t('message.gender')"
                                        label-for="gender">
                                    <b-form-select
                                            id="gender"
                                            v-model="$v.form.sexe.$model"
                                            :state="$v.form.sexe.$dirty ? !(errorshasField('sexe') || $v.form.sexe.$error) : null"
                                            :options="sexes"
                                            required
                                            @focus="clearErrorField('sexe')"
                                    ></b-form-select>

                                    <b-form-invalid-feedback v-if="!$v.form.sexe.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('sexe')">
                                        {{ getErrorsField('sexe') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                        </b-col>

                            <b-col sm="4">
<!--                                <span  class="obligatoire">*</span>-->
<!--                                <i class="fas fa-question float-right" id="popover-target-1"></i>-->
<!--                                <b-popover target="popover-target-1" triggers="hover" placement="top">-->
<!--                                    <template v-slot:title>{{$t('message.unknownDate')}}</template>-->
<!--                                    {{$t('message.unknownDateText')}}-->
<!--                                </b-popover>-->
                                <b-form-group
                                        id="dob-group"
                                        :label="$t('message.dob')"
                                        label-for="dob">
                                    <b-form-input
                                            id="dob"
                                            v-model="form.dob"
                                            type="date"
                                            :state="$v.form.dob.$dirty ? !(errorshasField('date_de_naissance') || $v.form.dob.$error) : null"
                                            placeholder=""
                                            @change="clearErrorField('date_de_naissance')"
                                    ></b-form-input>
<!--                                    <span v-if="errorshasField('date_de_naissance')" style="color:red">-->
<!--                                        {{ getErrorsField('date_de_naissance') }}-->
<!--                                    </span>-->
                                    <b-form-invalid-feedback v-if="$v.form.dob.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="nationalite-group"
                                        :label="$t('message.nationality')"
                                        label-for="nationalite"
                                >
                                    <b-form-input
                                            id="nationalite"
                                            v-model="form.nationalite"
                                            :state="$v.form.nationalite.$dirty ? !(errorshasField('nationalite') || $v.form.nationalite.$error) : null"
                                            @focus="clearErrorField('nationalite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('nationalite')">
                                        {{ getErrorsField('nationalite') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="single-group"
                                        :label="$t('message.select')+' '+$tc('message.countries', 1)"
                                        label-for="single">
                                    <!-- Options -->
                                    <select id="single"  v-model="form.pays" required
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option v-for="item in mCountries" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="errorshasField('pays')">
                                        {{ getErrorsField('pays') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.pays.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="ville-group"
                                        :label="$tc('message.cities', 1)"
                                        label-for="ville"
                                >
                                    <b-form-input
                                            id="ville"
                                            v-model="form.ville"
                                            :state="$v.form.ville.$dirty ? !(errorshasField('ville') || $v.form.ville.$error) : null"
                                            @focus="clearErrorField('ville')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="street-group"
                                        :label="$t('message.street')"
                                        label-for="street"
                                >
                                    <b-form-input
                                            id="street"
                                            v-model="$v.form.quartier.$model"
                                            :state="$v.form.quartier.$dirty ? !(errorshasField('quartier') || $v.form.quartier.$error) : null"
                                            @focus="clearErrorField('quartier')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                        {{ getErrorsField('quartier') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="zipCode-group"
                                        :label="$t('message.zipCode')"
                                        label-for="zipCode"
                                >
                                    <b-form-input
                                            id="zipCode"
                                            v-model="$v.form.code_postal.$model"
                                            :state="$v.form.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.code_postal.$error) : null"
                                            @focus="clearErrorField('code_postal')"
                                            type="number"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                        {{ getErrorsField('code_postal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="address-group"
                                        :label="$t('message.address')"
                                        label-for="address"
                                >
                                    <b-form-input
                                            id="address"
                                            v-model="form.adresse"
                                            :state="$v.form.adresse.$dirty ? !(errorshasField('adresse') || $v.form.adresse.$error) : null"
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>

<!--                                    <b-form-invalid-feedback v-else-if="!$v.form.adresse.required">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->

                                </b-form-group>

                            </b-col>

                        </b-row>

                    </div>

                    <b-container>
                        <b-row class="justify-content-center" v-if="can || hasAssistante">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>

                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import 'vue-tel-input/dist/vue-tel-input.css';
    import VueTelInput from 'vue-tel-input';
    
    import { mapGetters } from 'vuex';
    import { required, email,integer, minLength,numeric,maxLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import moment from 'moment';
    import SlimSelect from 'slim-select';

    Vue.use(VueTelInput, {
        dropdownOptions: {
            showSearchBox: true,
            showDialCodeInSelection: true
        },
        inputOptions: {
            required: true,
            autofocus: true,
            showDialCode: true
        },
        invalidMsg:'Saisissez un numéro de téléphone correct',
        preferredCountries: ['cm', 'be', 'fr']
    });

    export default {
        name: "AddSubscriber",

        computed: {
            ...mapGetters(["countries", "errors",'hasAdminRole',
                'hasGestionnaireRole',
            'hasPraticienRole','hasMedecinControleRole','hasAssistante'
            ]),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            },

            date_de_naissance: function() {
                return moment(this.form.dob).format('YYYY-MM-DD');
            }
        },

        data() {
            return {
                form: {
                    nom: '',
                    prenom: '',
                    adresse: '',
                    telephone: '',
                    email: '',
                    sexe: 'F',
                    dob: '',
                    nationalite: '',
                    ville: '',
                    pays: '',
                    quartier:'',
                    code_postal:'',
                    role: this.$route.params.role != null ? this.$route.params.role : localStorage.getItem('role')
                },
                mobileView: true,
                sexes: [
                    { value: 'F', text: this.$i18n.t('message.female') },
                    { value: 'M', text: this.$i18n.t('message.male') }
                ],
                show: true,
            }
        },

        methods: {
            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },
            handleView() {
            this.mobileView = window.innerWidth < 991;
            },
            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        nom: this.form.nom,
                        prenom: this.form.prenom,
                        adresse: this.form.adresse,
                        email: this.form.email,
                        telephone: this.form.telephone,
                        sexe: this.form.sexe,
                        date_de_naissance: this.form.dob,
                        nationalite: this.form.nationalite,
                        ville: this.form.ville,
                        pays: this.form.pays,
                        quartier: this.form.quartier,
                        code_postal: this.form.code_postal,
                        role: this.form.role
                    };
                    console.log(args);
                    let successMessage = this.$i18n.t('message.subscriberCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createSubscriber', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.nom = '';
                this.form.prenom = '';
                this.form.adresse = '';
                this.form.email = '';
                this.form.telephone = '';
                this.form.sexe = 'F';
                this.form.dob = null;
                this.form.nationalite = '';
                this.form.ville = '';
                this.form.pays = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                nom: {
                    required
                },
                prenom: {
                    //
                },
                adresse: {
                    // required
                },
                telephone: {
                    required,
                    minLength: minLength(6),
                },
                email: {
                    required,
                    email
                },
                sexe: {
                    required
                },
                dob: {
                    // required
                },
                nationalite: {
                    //
                },
                ville: {
                    required
                },
                pays: {
                    required
                },

                quartier:{

                },

                code_postal:{

                }
            }
        },
        created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
        },

        mounted() {
            // Retrieve list of countries
            this.getCountries();

            new SlimSelect({
                select: '#single',
                placeholder: 'Select your country'
            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>